/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Guide_Import_SeparatelyInputs */

const en_google_drive_guide_import_separately = /** @type {(inputs: Google_Drive_Guide_Import_SeparatelyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choosing files gives Listening access. Nothing is imported until you tap Import.`)
};

const es_google_drive_guide_import_separately = /** @type {(inputs: Google_Drive_Guide_Import_SeparatelyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al elegir archivos, das acceso a Listening. No se importa nada hasta que pulses Importar.`)
};

/**
* | output |
* | --- |
* | "Choosing files gives Listening access. Nothing is imported until you tap Import." |
*
* @param {Google_Drive_Guide_Import_SeparatelyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_guide_import_separately = /** @type {((inputs?: Google_Drive_Guide_Import_SeparatelyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Guide_Import_SeparatelyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_guide_import_separately(inputs)
	return en_google_drive_guide_import_separately(inputs)
});